let sheet = null;

export default function overridePositionFunc({ left, top }, event, triggerElement, tooltipElement) {
    // Left position of the element you hovered over + half it's width
    //  This is were the tooltip is positioned bottom, the arrow position to the middle of the triggered element
    const arrowLeft = triggerElement.getBoundingClientRect().left + triggerElement.offsetWidth / 2;

    // The triggering element's bottom edge
    const arrowTop = triggerElement.getBoundingClientRect().top + triggerElement.offsetHeight + 4;

    // This is were the tooltip is rendered left, the arrow position to the middle of the triggered element
    const tooltipLeftPosition = triggerElement.getBoundingClientRect().left - 12;
    const tooltipTopPosition =
        triggerElement.getBoundingClientRect().top + triggerElement.offsetHeight / 2;

    const isSheetNull = sheet === null;

    if (!sheet) {
        sheet = document.createElement("style");
    }

    // After and before are black border triangle and white triangle
    sheet.innerHTML = `
      .__react_component_tooltip.place-bottom::after {
        position: fixed;
        top: ${arrowTop + 1}px;
        left: ${arrowLeft}px;
      }
      .__react_component_tooltip.place-bottom::before {
        position: fixed;
        top: ${arrowTop - 1}px;
        left: ${arrowLeft}px;
      }
    `;

    sheet.innerHTML += `
      .__react_component_tooltip.place-left::after {
        position: fixed;
        top: ${tooltipTopPosition}px;
        left: ${tooltipLeftPosition - 1}px;
      }
      .__react_component_tooltip.place-left::before {
        position: fixed;
        top: ${tooltipTopPosition}px;
        left: ${tooltipLeftPosition - 1}px;
      }
    `;

    if (isSheetNull) {
        document.body.appendChild(sheet);
    }

    const overrideTop = top < 0 ? 10 : top;

    // https://github.com/wwayne/react-tooltip/issues/476
    return {
        left: Math.min(left, window.innerWidth - tooltipElement.offsetWidth - 10),
        top: overrideTop
    };
}
